var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccessCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 128C28.6667 128 0 99.3333 0 64C0 28.6667 28.6667 0 64 0C99.3333 0 128 28.6667 128 64C128 99.3333 99.3333 128 64 128ZM64 7.06667C32.6667 7.06667 7.06667 32.6667 7.06667 64C7.06667 95.3333 32.6667 120.933 64 120.933C95.3333 120.933 120.933 95.3333 120.933 64C120.933 32.6667 95.3333 7.06667 64 7.06667Z",
    fill: "#08974B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0672 81.3333C56.1339 81.3333 55.2006 80.9333 54.5339 80.2666L40.9339 66.6666C39.6006 65.3333 39.3339 63.0666 40.5339 61.7333C41.8672 60.1333 44.2672 59.9999 45.7339 61.4666L57.0672 72.7999C57.0672 72.7999 57.0672 72.7999 57.2006 72.7999L82.4006 47.5999C83.7339 46.2666 85.8672 45.9999 87.3339 47.1999C88.9339 48.5333 89.0672 50.9333 87.6006 52.3999L59.6006 80.3999C58.9339 81.0666 58.0006 81.3333 57.0672 81.3333Z",
    fill: "#08974B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessCheck);
export default __webpack_public_path__ + "static/media/access_check.8e73956f35554805e2a52f5afb30469c.svg";
export { ForwardRef as ReactComponent };